import { render } from "./index.vue?vue&type=template&id=cf6418ea&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=cf6418ea&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\YCTECH\\ycform\\trunk\\ycform-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf6418ea"]])

export default __exports__